import { render, staticRenderFns } from "./DormRoomAddForm.vue?vue&type=template&id=b344f5fc&scoped=true&"
import script from "./DormRoomAddForm.vue?vue&type=script&lang=js&"
export * from "./DormRoomAddForm.vue?vue&type=script&lang=js&"
import style0 from "./DormRoomAddForm.vue?vue&type=style&index=0&id=b344f5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b344f5fc",
  null
  
)

export default component.exports